/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { createEphemeralBlobStore };
class EphemeralBlobsImpl {
    #byBlobHandle = new Map();
    #byEphemeralHandle = new Map();
    byEphemeralHandle(handle) {
        return this.#byEphemeralHandle.get(handle);
    }
    byPersistentHandle(handle) {
        return this.#byBlobHandle.get(handle);
    }
    add(blob, persistent) {
        const ephemeral = URL.createObjectURL(blob);
        persistent ??= `files:${crypto.randomUUID()}`;
        this.#byBlobHandle.set(persistent, ephemeral);
        this.#byEphemeralHandle.set(ephemeral, persistent);
        return { ephemeral, persistent };
    }
    get size() {
        return this.#byBlobHandle.size;
    }
}
function createEphemeralBlobStore() {
    return new EphemeralBlobsImpl();
}
//# sourceMappingURL=ephemeral-blob-store.js.map